(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.NBBBlogPopup = api;
    var boot = function () {
      var popupRoot = root.document && root.document.getElementById('nbb-blog-guide');
      if (popupRoot && root.NBBBlogPopupCore) api.create(popupRoot, { core: root.NBBBlogPopupCore });
    };
    if (root.document && root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var activeInstance = null;
  var STAGE_ORDER = ['brand', 'email', 'model', 'size', 'usecase', 'result'];
  var STEP_NUMBERS = { brand: 1, email: 2, model: 3, size: 4, usecase: 5, result: 5 };
  var STAGE_NUMBERS = { brand: 1, email: 2, model: 3, size: 4, usecase: 5, result: 6 };
  var SCRATCH_THRESHOLD = 0.50;
  var DAY_MS = 24 * 60 * 60 * 1000;
  var TEASER_COOLDOWN_DAYS = [1, 3, 7, 30];
  var FIXED_SURFACE_SESSION_KEY = 'nbb_fixed_popup_session_v1';
  var FIXED_SURFACE_SESSION_MS = 30 * 60 * 1000;
  var DYNAMIC_ICONS = {
    size: '<svg viewBox="0 0 24 24"><path d="M4 7h16v10H4V7Zm4 0v4m4-4v2m4-2v4"/></svg>'
  };

  function create(root, dependencies) {
    if (!root) throw new Error('NBB popup root is required');
    if (activeInstance) activeInstance.destroy();

    dependencies = dependencies || {};
    var doc = root.ownerDocument;
    var win = doc.defaultView;
    var core = dependencies.core || win.NBBBlogPopupCore;
    var now = dependencies.now || Date.now;
    var storage = dependencies.storage || win.localStorage;
    var analytics = dependencies.analytics || win.NBBAnalytics;
    var fetcher = dependencies.fetch || (win.fetch && win.fetch.bind(win));
    var rewardRevealDelay = typeof dependencies.rewardRevealDelay === 'number'
      ? Math.max(0, dependencies.rewardRevealDelay)
      : (win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches ? 20 : 1750);
    if (!core) throw new Error('NBBBlogPopupCore is required');

    function hydrateArticleTeasers() {
      var identity = (root.dataset.articleTitle || '') + ' ' + (root.dataset.articleHandle || '');
      var content = core.articleTeaserContent(identity, root.dataset.brand || '');
      var targets = {
        '[data-inline-eyebrow]': content.inlineEyebrow,
        '[data-inline-heading]': content.inlineHeading,
        '[data-inline-body]': content.inlineBody,
        '[data-corner-title]': content.cornerTitle,
        '[data-corner-detail]': content.cornerDetail
      };
      Object.keys(targets).forEach(function (selector) {
        var element = root.querySelector(selector);
        if (element) element.textContent = targets[selector];
      });
      root.dataset.articleContext = content.kind;
    }

    hydrateArticleTeasers();

    var overlay = root.querySelector('[data-popup-overlay]');
    var dialog = root.querySelector('[role="dialog"]');
    var emailForm = root.querySelector('[data-email-form]');
    var emailInput = root.querySelector('[name="email"]');
    var emailError = root.querySelector('[data-email-error]');
    var minimized = root.querySelector('[data-minimized], .nbb-bp__minimized');
    var minimizedShell = root.querySelector('[data-minimized-shell]');
    var teaserDismiss = root.querySelector('[data-dismiss-blog-teaser]');
    var state = {
      stage: 'brand',
      history: [],
      brand: root.dataset.brand || '',
      email: '',
      model: '',
      size: '',
      usecase: '',
      selectedModel: null,
      signup: null,
      submitting: false,
      revealed: false,
      couponShown: false,
      scratchStarted: false,
      interactionStarted: false,
      teaserViewed: false,
      suppressed: false,
      fallbackSuppressed: false,
      turnstileWidgetId: null,
      turnstilePending: false,
      turnstileToken: ''
    };
    var previousFocus = null;
    var listeners = [];
    var timers = [];
    var viewedStages = new Set();
    var scratchCleanup = function () {};
    var destroyed = false;

    function safeGet(key) {
      try { return storage.getItem(key); } catch (_error) { return null; }
    }

    function safeSet(key, value) {
      try { storage.setItem(key, String(value)); } catch (_error) {}
    }

    function teaserCooldownMs(dismissalCount) {
      var count = Math.max(1, Math.floor(Number(dismissalCount) || 1));
      return TEASER_COOLDOWN_DAYS[Math.min(count - 1, TEASER_COOLDOWN_DAYS.length - 1)] * DAY_MS;
    }

    function teaserDismissalCount() {
      var storedCount = Math.floor(Number(safeGet('nbb_blog_popup_v2_teaser_dismiss_count') || 0));
      if (storedCount > 0) return storedCount;
      return Number(safeGet('nbb_blog_popup_v2_teaser_dismissed') || 0) > 0 ? 1 : 0;
    }

    function fixedSurfaceClaimed() {
      var claimedAt = Number(safeGet(FIXED_SURFACE_SESSION_KEY) || 0);
      return claimedAt > 0 && now() - claimedAt < FIXED_SURFACE_SESSION_MS;
    }

    function claimFixedSurface() {
      safeSet(FIXED_SURFACE_SESSION_KEY, now());
    }

    try {
      var completedAt = Number(safeGet('nbb_blog_popup_v2_completed'));
      var dismissedAt = Number(safeGet('nbb_blog_popup_v2_dismissed'));
      var teaserDismissedAt = Number(safeGet('nbb_blog_popup_v2_teaser_dismissed'));
      var teaserDismissCount = teaserDismissalCount();
      state.suppressed = Number.isFinite(completedAt) && completedAt > 0;
      state.fallbackSuppressed = (
        Number.isFinite(dismissedAt) && dismissedAt > 0 && now() - dismissedAt < 30 * DAY_MS
      ) || (
        Number.isFinite(teaserDismissedAt) && teaserDismissedAt > 0 &&
        now() - teaserDismissedAt < teaserCooldownMs(teaserDismissCount || 1)
      ) || fixedSurfaceClaimed();
      if (state.suppressed) root.hidden = true;
    } catch (_error) {}

    function on(target, name, handler, options) {
      if (!target) return;
      target.addEventListener(name, handler, options);
      listeners.push(function () { target.removeEventListener(name, handler, options); });
    }

    function emit(action, extra) {
      var detail = Object.assign({
        action: action,
        stage: state.stage,
        source: 'blog_popup_v2',
        articleHandle: root.dataset.articleHandle || ''
      }, extra || {});
      root.dispatchEvent(new win.CustomEvent('nbb:blog-popup', { bubbles: true, detail: detail }));
      if (!analytics || typeof analytics.publish !== 'function' || state.suppressed) return;
      var base = {
        popup_id: 'blog_guide',
        popup_version: 'blog_popup_v2',
        popup_variant: 'none',
        popup_surface: detail.surface || (action === 'open' && detail.trigger === 'minimized' ? 'teaser' : 'inline'),
        page_type: 'article',
        article_handle: root.dataset.articleHandle || '',
        blog_type: root.dataset.articleContext || 'fallback',
        locale: root.dataset.lang || 'en'
      };
      if (action === 'view') {
        analytics.publish('popup_eligible', base);
      } else if (action === 'teaser_view') {
        if (state.teaserViewed) return;
        state.teaserViewed = true;
        analytics.publish('popup_teaser_viewed', base);
      } else if (action === 'open') {
        base.popup_trigger = detail.trigger === 'minimized' ? 'teaser' : 'inline';
        analytics.publish('popup_opened', base);
      } else if (action === 'stage') {
        var stage = detail.stage || state.stage;
        if (viewedStages.has(stage)) return;
        viewedStages.add(stage);
        base.step_id = stage;
        base.step_number = STAGE_NUMBERS[stage] || 0;
        analytics.publish('popup_step_viewed', base);
      } else if (action === 'interaction_start') {
        analytics.publish('popup_interaction_started', base);
      } else if (action === 'scratch_start') {
        analytics.publish('popup_scratch_started', base);
      } else if (action === 'email_submit') analytics.publish('popup_email_attempted', base);
      else if (action === 'email_success') analytics.publish('popup_signup_completed', base);
      else if (action === 'profile_complete') analytics.publish('popup_profile_completed', base);
      else if (action === 'scratch_reveal') analytics.publish('popup_offer_revealed', base);
      else if (action === 'coupon_copy') analytics.publish('popup_coupon_copied', base);
      else if (action === 'close') analytics.publish('popup_dismissed', base);
      else if (action === 'error') {
        base.error_category = detail.code || 'unknown';
        analytics.publish('popup_error', base);
      }
    }

    function startInteraction() {
      if (state.interactionStarted) return;
      state.interactionStarted = true;
      emit('interaction_start');
    }

    function publishProfileStep(eventName, stepId) {
      if (!analytics || typeof analytics.publish !== 'function' || state.suppressed) return;
      analytics.publish(eventName, {
        popup_id: 'blog_guide',
        popup_version: 'blog_popup_v2',
        popup_variant: 'none',
        popup_surface: 'inline',
        popup_trigger: 'inline',
        step_id: stepId,
        step_number: STEP_NUMBERS[stepId] || 0,
        page_type: 'article',
        article_handle: root.dataset.articleHandle || '',
        blog_type: root.dataset.articleContext || 'fallback',
        locale: root.dataset.lang || 'en'
      });
    }

    function focusableElements() {
      return Array.prototype.slice.call(dialog.querySelectorAll(
        'button:not([disabled]):not([hidden]), input:not([disabled]):not([hidden]), a[href], [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return !element.closest('[hidden]');
      });
    }

    function choiceIcon(kind) {
      var icon = doc.createElement('span');
      icon.className = 'nbb-bp__choice-icon';
      icon.dataset.choiceIcon = kind;
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = DYNAMIC_ICONS[kind] || '';
      return icon;
    }

    function updateProgress(stage) {
      var step = STEP_NUMBERS[stage] || 1;
      var percent = Math.round((step / 5) * 100);
      var stepLabel = root.querySelector('[data-step-label]');
      var stepPercent = root.querySelector('[data-step-percent]');
      var mobileStep = root.querySelector('[data-mobile-step]');
      if (stepLabel) stepLabel.textContent = stage === 'result' ? 'Briefing ready' : 'Step ' + step + ' of 5';
      if (stepPercent) stepPercent.textContent = percent + '%';
      if (mobileStep) mobileStep.textContent = stage === 'result' ? 'Ready' : step + ' / 5';
      ['[data-progress-fill]', '[data-mobile-progress-fill]'].forEach(function (selector) {
        var fill = root.querySelector(selector);
        if (fill) fill.style.width = percent + '%';
      });
    }

    function ensureTurnstile() {
      var sitekey = root.dataset.turnstileSiteKey;
      var container = root.querySelector('[data-turnstile]');
      if (!sitekey || !container || state.turnstileWidgetId !== null || state.turnstilePending) return;
      if (win.turnstile && typeof win.turnstile.render === 'function') {
        state.turnstileWidgetId = win.turnstile.render(container, {
          sitekey: sitekey,
          action: root.dataset.turnstileAction || 'blog_popup_signup',
          theme: 'light',
          size: 'flexible',
          callback: function (token) { state.turnstileToken = token || ''; },
          'expired-callback': function () { state.turnstileToken = ''; },
          'error-callback': function () { state.turnstileToken = ''; },
          'timeout-callback': function () { state.turnstileToken = ''; }
        });
        return;
      }
      state.turnstilePending = true;
      var attempts = 0;
      var retry = function () {
        attempts += 1;
        if (win.turnstile && typeof win.turnstile.render === 'function') {
          state.turnstilePending = false;
          ensureTurnstile();
          return;
        }
        if (attempts >= 20) { state.turnstilePending = false; return; }
        var retryTimer = win.setTimeout(retry, 250);
        timers.push(retryTimer);
      };
      var timer = win.setTimeout(retry, 250);
      timers.push(timer);
    }

    function resetTurnstile() {
      state.turnstileToken = '';
      if (state.turnstileWidgetId === null || !win.turnstile || typeof win.turnstile.reset !== 'function') return;
      try { win.turnstile.reset(state.turnstileWidgetId); } catch (_error) {}
    }

    function showStage(stage, options) {
      options = options || {};
      if (state.stage !== stage && options.remember !== false) state.history.push(state.stage);
      state.stage = stage;
      Array.prototype.forEach.call(root.querySelectorAll('[data-stage]'), function (section) {
        var active = section.dataset.stage === stage;
        section.hidden = !active;
        var heading = section.querySelector('h2');
        if (heading) {
          if (active) heading.id = 'nbb-bp-stage-heading';
          else heading.removeAttribute('id');
        }
      });
      var back = root.querySelector('[data-back]');
      if (back) back.hidden = stage === 'brand' || stage === 'result';
      updateProgress(stage);
      if (stage === 'email') ensureTurnstile();
      emit('stage', { stage: stage, step: STEP_NUMBERS[stage] });
      var activeStage = root.querySelector('[data-stage="' + stage + '"]');
      var target = activeStage && activeStage.querySelector('button, input, [tabindex]');
      if (overlay && !overlay.hidden && target && options.focus !== false) target.focus();
    }

    function openPopup(opener) {
      previousFocus = opener || doc.activeElement;
      overlay.hidden = false;
      overlay.classList.add('is-opening');
      doc.body.classList.add('nbb-bp-scroll-locked');
      if (minimizedShell) minimizedShell.hidden = true;
      else if (minimized) minimized.hidden = true;
      dialog.focus();
      var teaserOpener = opener && opener.matches('[data-minimized], .nbb-bp__minimized');
      emit('open', { trigger: teaserOpener ? 'minimized' : 'inline' });
      emit('stage', { stage: state.stage, step: STAGE_NUMBERS[state.stage] });
      var timer = win.setTimeout(function () { overlay.classList.remove('is-opening'); }, 300);
      timers.push(timer);
    }

    function closePopup(reason) {
      if (overlay.hidden) return;
      overlay.hidden = true;
      overlay.classList.remove('is-opening');
      doc.body.classList.remove('nbb-bp-scroll-locked');
      emit('close', { reason: reason || 'button' });
      if (!state.revealed) {
        safeSet('nbb_blog_popup_v2_dismissed', now());
      }
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      if (!state.revealed && minimized && state.stage !== 'brand') {
        if (minimizedShell) minimizedShell.hidden = false;
        else minimized.hidden = false;
      }
    }

    function dismissTeaser() {
      if (destroyed || !minimized || !overlay.hidden) return;
      state.fallbackSuppressed = true;
      safeSet('nbb_blog_popup_v2_teaser_dismiss_count', teaserDismissalCount() + 1);
      safeSet('nbb_blog_popup_v2_teaser_dismissed', now());
      if (minimizedShell) minimizedShell.hidden = true;
      else minimized.hidden = true;
      emit('close', { reason: 'teaser', surface: 'teaser' });
    }

    function renderModels(query) {
      var container = root.querySelector('[data-model-results]');
      if (!container) return;
      container.textContent = '';
      var models = core.modelsForBrand(state.brand, query || '');
      models.forEach(function (model, index) {
        var button = doc.createElement('button');
        button.type = 'button';
        button.setAttribute('role', 'option');
        button.dataset.modelIndex = String(index);
        button._nbbModel = model;
        var copy = doc.createElement('span');
        copy.className = 'nbb-bp__choice-copy';
        var name = doc.createElement('span');
        name.textContent = model.name;
        var sizes = doc.createElement('small');
        sizes.textContent = model.sizes.join(' · ');
        copy.appendChild(name);
        copy.appendChild(sizes);
        button.appendChild(copy);
        container.appendChild(button);
      });
    }

    function renderSizes(model) {
      var container = root.querySelector('[data-size-options]');
      if (!container) return;
      container.textContent = '';
      (model && model.sizes || []).forEach(function (size) {
        var button = doc.createElement('button');
        button.type = 'button';
        button.dataset.sizeChoice = size;
        button.appendChild(choiceIcon('size'));
        var copy = doc.createElement('span');
        copy.className = 'nbb-bp__choice-copy';
        var label = doc.createElement('span');
        label.textContent = size;
        copy.appendChild(label);
        button.appendChild(copy);
        container.appendChild(button);
      });
    }

    function klaviyoIdentify(properties) {
      try {
        var queue = win.klaviyo || win._learnq;
        if (queue && typeof queue.identify === 'function') queue.identify(properties);
        else if (queue && typeof queue.push === 'function') queue.push(['identify', properties]);
      } catch (_error) {
        emit('error', { code: 'identify_unavailable' });
      }
    }

    function submitEmail(event) {
      event.preventDefault();
      if (state.submitting) return;
      startInteraction();
      var value = emailInput.value;
      if (!core.isValidEmail(value)) {
        emailError.textContent = 'Please enter a valid email address.';
        emailError.hidden = false;
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
        emit('error', { code: 'invalid_email' });
        return;
      }
      var endpoint = root.dataset.signupEndpoint;
      if (!endpoint || !fetcher) {
        emailError.textContent = 'This guide is not connected yet. Please try again shortly.';
        emailError.hidden = false;
        emit('error', { code: 'missing_endpoint' });
        return;
      }

      emailError.hidden = true;
      emailInput.removeAttribute('aria-invalid');
      state.email = core.normalizeEmail(value);
      state.submitting = true;
      var submitButton = emailForm.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;
      var turnstile = root.querySelector('[name="cf-turnstile-response"]');
      var payload = core.buildSignupPayload(state, {
        lang: root.dataset.lang,
        articleHandle: root.dataset.articleHandle,
        turnstileToken: state.turnstileToken || (turnstile ? turnstile.value : '')
      });
      emit('email_submit');

      Promise.resolve(fetcher(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })).then(function (response) {
        if (!response || !response.ok) throw new Error('signup_request_failed');
        return response.json();
      }).then(function (result) {
        if (!result || result.ok === false) throw new Error(result && result.error || 'signup_rejected');
        state.signup = result;
        emit('email_success');
        publishProfileStep('popup_profile_started', 'model');
        klaviyoIdentify({ '$email': state.email, 'Watch Brand': state.brand || 'Other', 'Signup Source': 'blog_popup_v2' });
        renderModels('');
        showStage('model');
      }).catch(function () {
        emailError.textContent = 'We couldn’t save your guide just now. Please try once more.';
        emailError.hidden = false;
        resetTurnstile();
        emit('error', { code: 'signup_failed' });
      }).then(function () {
        state.submitting = false;
        if (submitButton) submitButton.disabled = false;
      });
    }

    function finishProfile() {
      var watch = [state.model || core.brandLabel(state.brand), state.size].filter(Boolean).join(' · ');
      var material = core.recommendMaterial(state.usecase);
      var watchOutput = root.querySelector('[data-result-watch]');
      var materialOutput = root.querySelector('[data-result-material]');
      var scratchPrize = root.querySelector('[data-scratch-prize]');
      var coupon = root.querySelector('[data-coupon]');
      var couponCode = root.querySelector('[data-coupon-code]');
      var copyButton = root.querySelector('[data-copy-coupon]');
      var copyLabel = root.querySelector('[data-copy-label]');
      var scratchStatus = root.querySelector('[data-scratch-status]');
      var code = state.signup && typeof state.signup.couponCode === 'string' ? state.signup.couponCode.trim() : '';
      if (watchOutput) watchOutput.textContent = watch || 'Your watch';
      if (materialOutput) materialOutput.textContent = material;
      if (couponCode) couponCode.textContent = code || 'Check your inbox';
      if (copyButton) copyButton.disabled = true;
      if (copyLabel) copyLabel.textContent = code ? 'Tap to copy' : 'Sent by email';
      if (scratchPrize) scratchPrize.setAttribute('aria-hidden', 'true');
      if (coupon) coupon.setAttribute('aria-hidden', 'true');
      if (scratchStatus) scratchStatus.textContent = code
        ? 'Your subscriber gift is ready to reveal.'
        : 'Your subscriber gift will arrive securely in your inbox.';
      showStage('result');
      emit('profile_complete', {
        brand: state.brand || 'Other',
        hasModel: Boolean(state.model),
        hasSize: Boolean(state.size),
        usecase: state.usecase || 'unspecified'
      });
      klaviyoIdentify({
        '$email': state.email,
        'Watch Brand': state.brand || 'Other',
        'Watch Model': state.model,
        'Watch Size': state.size,
        'Watch Use Case': state.usecase
      });
      setupScratch();
      safeSet('nbb_blog_popup_v2_completed', now());
    }

    function revealScratch(method) {
      if (state.revealed) return;
      state.revealed = true;
      var reward = root.querySelector('[data-reward]');
      var scratchPrize = root.querySelector('[data-scratch-prize]');
      var coupon = root.querySelector('[data-coupon]');
      var copyButton = root.querySelector('[data-copy-coupon]');
      var status = root.querySelector('[data-scratch-status]');
      var code = state.signup && typeof state.signup.couponCode === 'string' ? state.signup.couponCode.trim() : '';
      if (reward) {
        reward.classList.add('is-revealed');
        reward.classList.add(method === 'scratch' ? 'is-scratch-revealed' : 'is-button-revealed');
      }
      if (coupon) coupon.setAttribute('aria-hidden', 'true');
      if (scratchPrize) scratchPrize.setAttribute('aria-hidden', 'false');
      if (copyButton) copyButton.disabled = true;
      if (status) status.textContent = code
        ? 'You unlocked 10% off. Your code is being revealed.'
        : 'Your subscriber gift will arrive securely in your inbox.';
      emit('scratch_reveal', { method: method || 'button' });
      timers.push(win.setTimeout(showCoupon, rewardRevealDelay));
    }

    function showCoupon() {
      if (!state.revealed || state.couponShown) return;
      state.couponShown = true;
      var reward = root.querySelector('[data-reward]');
      var scratchPrize = root.querySelector('[data-scratch-prize]');
      var coupon = root.querySelector('[data-coupon]');
      var copyButton = root.querySelector('[data-copy-coupon]');
      var status = root.querySelector('[data-scratch-status]');
      var code = state.signup && typeof state.signup.couponCode === 'string' ? state.signup.couponCode.trim() : '';
      if (reward) reward.classList.add('is-coupon-shown');
      if (scratchPrize) scratchPrize.setAttribute('aria-hidden', 'true');
      if (coupon) coupon.setAttribute('aria-hidden', 'false');
      if (copyButton) copyButton.disabled = !code;
      if (status) status.textContent = code
        ? 'Your 10% discount code is ready. Tap the code to copy it.'
        : 'Your subscriber gift will arrive securely in your inbox.';
      emit('coupon_reveal');
    }

    function fallbackCopy(value) {
      var field = doc.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      doc.body.appendChild(field);
      field.select();
      var copied = false;
      try { copied = Boolean(doc.execCommand && doc.execCommand('copy')); } catch (_error) {}
      doc.body.removeChild(field);
      return copied ? Promise.resolve() : Promise.reject(new Error('copy_failed'));
    }

    function copyCoupon() {
      var code = state.signup && typeof state.signup.couponCode === 'string' ? state.signup.couponCode.trim() : '';
      if (!state.couponShown || !code) return;
      var clipboard = win.navigator && win.navigator.clipboard;
      var write = clipboard && typeof clipboard.writeText === 'function'
        ? Promise.resolve(clipboard.writeText(code)).catch(function () { return fallbackCopy(code); })
        : fallbackCopy(code);
      write.then(function () {
        var label = root.querySelector('[data-copy-label]');
        var button = root.querySelector('[data-copy-coupon]');
        var status = root.querySelector('[data-scratch-status]');
        if (label) label.textContent = 'Copied \u2713';
        if (button) button.setAttribute('aria-label', 'Discount code copied');
        if (status) status.textContent = 'Discount code ' + code + ' copied to your clipboard.';
        emit('coupon_copy');
      }).catch(function () {
        var status = root.querySelector('[data-scratch-status]');
        if (status) status.textContent = 'Could not copy automatically. Select the code and copy it manually.';
      });
    }

    function setupScratch() {
      scratchCleanup();
      var reward = root.querySelector('[data-reward]');
      var canvas = root.querySelector('[data-scratch-canvas]');
      var coin = root.querySelector('[data-scratch-coin]');
      if (!reward || !canvas || !win.CanvasRenderingContext2D) return;
      var context;
      try { context = canvas.getContext('2d'); } catch (_error) { return; }
      if (!context) return;
      var rectangle = reward.getBoundingClientRect();
      var width = Math.max(1, Math.round(rectangle.width));
      var height = Math.max(1, Math.round(rectangle.height));
      var ratio = Math.min(win.devicePixelRatio || 1, 2);
      canvas.width = width * ratio;
      canvas.height = height * ratio;
      context.scale(ratio, ratio);
      var foil = context.createLinearGradient ? context.createLinearGradient(0, 0, width, height) : null;
      if (foil) {
        foil.addColorStop(0, '#585852');
        foil.addColorStop(0.48, '#2f2f2c');
        foil.addColorStop(1, '#676760');
      }
      context.fillStyle = foil || '#3b3b37';
      context.fillRect(0, 0, width, height);

      var shine = context.createLinearGradient ? context.createLinearGradient(width * 0.12, height, width * 0.82, 0) : null;
      if (shine) {
        shine.addColorStop(0, 'rgba(255,255,255,0)');
        shine.addColorStop(0.38, 'rgba(255,255,255,0.04)');
        shine.addColorStop(0.53, 'rgba(255,255,255,0.30)');
        shine.addColorStop(0.68, 'rgba(255,255,255,0.05)');
        shine.addColorStop(1, 'rgba(255,255,255,0)');
        context.fillStyle = shine;
        context.fillRect(0, 0, width, height);
      }

      context.save();
      context.globalAlpha = 0.09;
      context.strokeStyle = '#ffffff';
      context.lineWidth = 0.6;
      for (var brush = 0; brush < 34; brush += 1) {
        var brushY = ((brush * 19) % height) + 0.5;
        context.beginPath();
        context.moveTo(0, brushY);
        context.lineTo(width, Math.max(0, brushY - 7));
        context.stroke();
      }
      context.globalAlpha = 0.22;
      for (var fleck = 0; fleck < 190; fleck += 1) {
        var fleckX = (fleck * 47 + fleck * fleck * 3) % width;
        var fleckY = (fleck * 29 + fleck * fleck * 5) % height;
        context.fillStyle = fleck % 4 === 0 ? '#171714' : '#ffffff';
        context.fillRect(fleckX, fleckY, fleck % 5 === 0 ? 2 : 1, fleck % 7 === 0 ? 2 : 1);
      }
      context.restore();
      context.fillStyle = '#b2f451';
      context.font = '700 13px Poppins, Arial, sans-serif';
      context.textAlign = 'center';
      context.fillText('SCRATCH TO REVEAL', width / 2, height / 2);
      context.globalCompositeOperation = 'destination-out';
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.lineWidth = 20;
      reward.classList.remove('is-revealed', 'is-scratch-revealed', 'is-button-revealed');
      reward.classList.add('is-scratch-ready');

      var scratching = false;
      var lastPoint = null;
      var coverageFrame = 0;
      var requestFrame = win.requestAnimationFrame
        ? win.requestAnimationFrame.bind(win)
        : function (callback) { return win.setTimeout(function () { callback(Date.now()); }, 16); };
      var cancelFrame = win.cancelAnimationFrame
        ? win.cancelAnimationFrame.bind(win)
        : win.clearTimeout.bind(win);

      function point(event) {
        var bounds = canvas.getBoundingClientRect();
        return { x: event.clientX - bounds.left, y: event.clientY - bounds.top };
      }

      function moveCoin(position, active) {
        if (!coin || !position) return;
        coin.style.setProperty('--nbb-coin-x', position.x + 'px');
        coin.style.setProperty('--nbb-coin-y', position.y + 'px');
        coin.classList.toggle('is-active', Boolean(active));
      }

      function measureCoverage() {
        coverageFrame = 0;
        if (state.revealed || typeof core.scratchedRatio !== 'function') return;
        try {
          var image = context.getImageData(0, 0, canvas.width, canvas.height);
          var scratched = core.scratchedRatio(image, Math.max(1, Math.round(ratio * 3)));
          reward.style.setProperty('--nbb-scratch-progress', Math.min(scratched / SCRATCH_THRESHOLD, 1));
          if (scratched >= SCRATCH_THRESHOLD) revealScratch('scratch');
        } catch (_error) {}
      }

      function scheduleCoverageCheck() {
        if (coverageFrame || state.revealed) return;
        coverageFrame = -1;
        var scheduledFrame = requestFrame(measureCoverage);
        if (coverageFrame === -1) coverageFrame = scheduledFrame;
      }

      function scratchDot(position) {
        context.beginPath();
        context.arc(position.x, position.y, context.lineWidth / 2, 0, Math.PI * 2);
        context.fill();
      }

      function start(event) {
        if (state.revealed) return;
        scratching = true;
        lastPoint = point(event);
        moveCoin(lastPoint, true);
        scratchDot(lastPoint);
        scheduleCoverageCheck();
        if (!state.scratchStarted) {
          state.scratchStarted = true;
          startInteraction();
          emit('scratch_start');
        }
        if (canvas.setPointerCapture && event.pointerId !== undefined) canvas.setPointerCapture(event.pointerId);
      }

      function move(event) {
        if (!scratching || state.revealed) return;
        var next = point(event);
        moveCoin(next, true);
        context.beginPath();
        context.moveTo(lastPoint.x, lastPoint.y);
        context.lineTo(next.x, next.y);
        context.stroke();
        lastPoint = next;
        scheduleCoverageCheck();
      }

      function stop() {
        scratching = false;
        lastPoint = null;
        if (coin) coin.classList.remove('is-active');
      }
      canvas.addEventListener('pointerdown', start);
      canvas.addEventListener('pointermove', move);
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      scratchCleanup = function () {
        if (coverageFrame) cancelFrame(coverageFrame);
        canvas.removeEventListener('pointerdown', start);
        canvas.removeEventListener('pointermove', move);
        canvas.removeEventListener('pointerup', stop);
        canvas.removeEventListener('pointercancel', stop);
      };
    }

    function handleClick(event) {
      if (teaserDismiss && event.target.closest('[data-dismiss-blog-teaser]')) {
        event.preventDefault();
        event.stopPropagation();
        dismissTeaser();
        return;
      }
      var opener = event.target.closest('[data-open-popup]');
      if (opener && root.contains(opener)) { openPopup(opener); return; }
      if (event.target.closest('[data-close-popup]')) { closePopup('button'); return; }
      startInteraction();

      var brandChoice = event.target.closest('[data-brand-choice]');
      if (brandChoice) {
        state.brand = brandChoice.dataset.brandChoice;
        Array.prototype.forEach.call(root.querySelectorAll('[data-brand-choice]'), function (button) {
          button.setAttribute('aria-pressed', button === brandChoice ? 'true' : 'false');
        });
        publishProfileStep('popup_profile_step_completed', 'brand');
        showStage('email');
        return;
      }

      var modelChoice = event.target.closest('[data-model-index]');
      if (modelChoice && modelChoice._nbbModel) {
        state.selectedModel = modelChoice._nbbModel;
        state.model = state.selectedModel.name;
        publishProfileStep('popup_profile_step_completed', 'model');
        if (core.nextStageForModel(state.selectedModel) === 'size') {
          renderSizes(state.selectedModel);
          showStage('size');
        } else showStage('usecase');
        return;
      }

      if (event.target.closest('[data-show-custom-model]')) {
        var custom = root.querySelector('[data-custom-model]');
        if (custom) custom.hidden = false;
        var customInput = root.querySelector('[data-custom-model-input]');
        if (customInput) customInput.focus();
        return;
      }

      if (event.target.closest('[data-use-custom-model]')) {
        var input = root.querySelector('[data-custom-model-input]');
        state.model = input ? input.value.trim() : '';
        publishProfileStep('popup_profile_step_completed', 'model');
        showStage('usecase');
        return;
      }

      if (event.target.closest('[data-skip-model]')) {
        state.model = '';
        publishProfileStep('popup_profile_step_skipped', 'model');
        showStage('usecase');
        return;
      }
      var sizeChoice = event.target.closest('[data-size-choice]');
      if (sizeChoice) {
        state.size = sizeChoice.dataset.sizeChoice;
        publishProfileStep('popup_profile_step_completed', 'size');
        showStage('usecase');
        return;
      }
      if (event.target.closest('[data-skip-size]')) {
        state.size = '';
        publishProfileStep('popup_profile_step_skipped', 'size');
        showStage('usecase');
        return;
      }
      var usecase = event.target.closest('[data-usecase-choice]');
      if (usecase) {
        state.usecase = usecase.dataset.usecaseChoice;
        publishProfileStep('popup_profile_step_completed', 'usecase');
        finishProfile();
        return;
      }
      if (event.target.closest('[data-skip-usecase]')) {
        state.usecase = '';
        publishProfileStep('popup_profile_step_skipped', 'usecase');
        finishProfile();
        return;
      }
      if (event.target.closest('[data-scratch-fallback]')) { revealScratch('button'); return; }
      if (event.target.closest('[data-copy-coupon]')) { copyCoupon(); return; }
      if (event.target.closest('[data-back]') && state.history.length) showStage(state.history.pop(), { remember: false });
    }

    function handleInput(event) {
      startInteraction();
      if (event.target.matches('[data-model-search]')) renderModels(event.target.value);
    }

    function handleKeydown(event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); closePopup('escape'); return; }
      if (event.key !== 'Tab') return;
      var elements = focusableElements();
      if (!elements.length) { event.preventDefault(); dialog.focus(); return; }
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && doc.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && doc.activeElement === last) { event.preventDefault(); first.focus(); }
    }

    function showMinimizedPrompt() {
      if (!minimized || state.suppressed || state.fallbackSuppressed || state.revealed || !overlay.hidden) return;
      if (fixedSurfaceClaimed()) {
        state.fallbackSuppressed = true;
        return;
      }
      claimFixedSurface();
      if (minimizedShell) {
        minimizedShell.hidden = false;
        minimizedShell.classList.add('is-visible');
      } else minimized.hidden = false;
      minimized.classList.add('is-visible');
      emit('teaser_view', { surface: 'teaser' });
    }

    function setupGentleFallback() {
      var timer = win.setTimeout(showMinimizedPrompt, 30000);
      timers.push(timer);
      on(win, 'scroll', function () {
        var available = Math.max(doc.documentElement.scrollHeight - win.innerHeight, 1);
        var ratio = win.scrollY / available;
        if (ratio >= 0.45) showMinimizedPrompt();
      }, { passive: true });
      on(doc, 'mouseleave', function (event) {
        if (win.innerWidth > 720 && event.clientY <= 0) showMinimizedPrompt();
      });
    }

    on(root, 'click', handleClick);
    on(root, 'input', handleInput);
    on(emailForm, 'submit', submitEmail);
    on(doc, 'keydown', handleKeydown);
    on(overlay, 'click', function (event) { if (event.target === overlay) closePopup('overlay'); });
    setupGentleFallback();
    renderModels('');
    updateProgress('brand');
    if (state.brand) {
      var detected = root.querySelector('[data-brand-choice="' + state.brand + '"]');
      if (detected) detected.setAttribute('aria-pressed', 'true');
    }
    emit('view', { detectedBrand: state.brand || 'unknown' });

    var instance = {
      open: openPopup,
      close: closePopup,
      getState: function () { return Object.assign({}, state); },
      destroy: function () {
        if (destroyed) return;
        destroyed = true;
        scratchCleanup();
        listeners.splice(0).forEach(function (remove) { remove(); });
        timers.splice(0).forEach(function (timerId) { win.clearTimeout(timerId); });
        doc.body.classList.remove('nbb-bp-scroll-locked');
        if (activeInstance === instance) activeInstance = null;
      }
    };
    activeInstance = instance;
    return instance;
  }

  function destroy() {
    if (activeInstance) activeInstance.destroy();
  }

  return { create: create, destroy: destroy, STAGE_ORDER: STAGE_ORDER.slice() };
});
